import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

import { useInvalidateClientProfile } from './get-client-profile'

type UpdateClientProfileRequest = {
  data: FormData
}

const updateClientProfile = async (clientId: string, request: UpdateClientProfileRequest) => {
  const response = await authAPI.put(`/client/${clientId}`, request.data, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
  return response.data
}

export const useUpdateClientProfile = (clientId: string) => {
  const invalidate = useInvalidateClientProfile(clientId)

  return useMutation({
    mutationFn: (request: UpdateClientProfileRequest) => updateClientProfile(clientId, request),
    onSuccess: invalidate,
  })
}
